module.exports = __webpack_public_path__ + "media/bootstrap-icons/capslock-fill-b15db89d.svg";